import React from 'react';
import { Row, Col } from 'react-bootstrap5';
import { Link, useLocation } from 'react-router-dom';
import routes from 'app/routes';
import ExternalLink from 'components/Widgets/ExternalLink';
import SuccessActivatedText from '../Widgets/SuccessActivatedText';

export default function Activated() {
  const { state } = useLocation();
  const { plan } = state;

  const isFree = plan?.attributes?.is_free || false;

  return (
    <div className="content">
      <Row>
        <Col lg={{ span: 6, order: 'last' }}>
          <div className="bg-photo bg-members-onboarding-calculating-photo" />
        </Col>

        <Col lg={{ span: 6, order: 'first' }}>
          <div className="py-4 px-sm-4 p-xxl-5">
            <h1 className="mb-3">Congratulations!</h1>

            <p>Your policy has been activated.</p>

            <ExternalLink
              href={plan.attributes.one_report}
            >
              Download
            </ExternalLink>

            <SuccessActivatedText isFree={isFree} />

            <div className="d-flex justify-content-between">
              <Link
                to={routes.managers.policy.index}
                className="btn btn-outline-primary"
              >
                Close
              </Link>

              {isFree && (
              <a
                href={routes.managers.members.add}
                className="btn btn-primary"
              >
                Add Members
              </a>
              )}
              {!isFree && (
              <a
                href={routes.managers.billing.index}
                className="btn btn-primary"
              >
                Go to the Billing page
              </a>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
